module.exports = __webpack_public_path__ + "static/cai_services_dataintegration_enterprise-252061fee43f84467a1a0a77f56dbae5.png";